import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    description: 'Modal Header Edit Vendor Settings',
    defaultMessage: 'Edit Settings',
    id: 'LSXj6I',
  },
  errorBannerText: {
    description: 'Banner indicating an error occurred during the action',
    defaultMessage: 'An error occurred while attempting to update the settings. Please try again.',
    id: 'j9swa4',
  },
  shipstationAccount: {
    description: 'ShipStations specific Carriers modal sub-header label',
    defaultMessage: 'ShipStation Account',
    id: '4f8QkW',
  },
  nameInputLabel: {
    description: 'Nickname Associated to Vendor',
    defaultMessage: 'Vendor Name',
    id: 'v2gbLf',
  },
  saveButton: {
    description: 'Save button',
    defaultMessage: 'Save changes',
    id: 'LXZUd1',
  },
});

export default messages;
